/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import { call, put, takeLatest } from 'redux-saga/effects';

import { axiosMicro } from '~/services';
import * as Actions from './actions';

function* getScheduleBookStatistic({ payload }) {
  try {
    const response = yield call(() => axiosMicro.get(
      '/statistics/schedule-book',
      { params: payload },
    ));

    if (response?.status === 200) {
      yield put(Actions.getScheduleBookStatisticSuccess(response.data));
    }
  } catch (e) {
    if (e?.response?.data) {
      const messages = e.response.data;
      yield put(Actions.getScheduleBookStatisticFailure(messages));
    }
  }
}

// eslint-disable-next-line func-names
export default function* () {
  yield takeLatest(Actions.getScheduleBookStatisticRequest, getScheduleBookStatistic);
}
